<script setup>
import { computed } from 'vue';
import { useStoreGetters } from 'dashboard/composables/store';
import MultiSelect from 'dashboard/components-next/filter/inputs/MultiSelect.vue';

const props = defineProps({
  modelValue: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['update:modelValue']);

const getters = useStoreGetters();

// Get all custom attributes from the store
const allCustomAttributes = computed(
  () => getters['attributes/getAttributes'].value || []
);

// Format custom attributes for the multiselect
const customAttributeOptions = computed(() => {
  return allCustomAttributes.value
    .filter(attr => attr.attribute_description) // Only show attributes with descriptions
    .map(attr => {
      // attribute_model is a string: 'conversation_attribute' or 'contact_attribute'
      const modelLabel =
        attr.attribute_model === 'conversation_attribute'
          ? 'Conversation'
          : 'Contact';
      return {
        id: attr.attribute_key,
        name: `${attr.attribute_display_name} (${modelLabel})`,
      };
    });
});

// Use v-model directly for compatibility with multiselect
const selectedAttributes = computed({
  get() {
    if (!props.modelValue || props.modelValue.length === 0) return [];
    return customAttributeOptions.value.filter(option =>
      props.modelValue.includes(option.id)
    );
  },
  set(value) {
    const ids = Array.isArray(value) ? value.map(item => item.id) : [];
    emit('update:modelValue', ids);
  },
});
</script>

<template>
  <MultiSelect v-model="selectedAttributes" :options="customAttributeOptions" />
</template>
